import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import useA11yTracking from 'hooks/useA11yTracking';
import { useAuth } from 'hooks/useAuth';
import ManutencaoArrecadacao from 'pages/Manutencao/ManutencaoArrecadacao';
import { useEffect } from 'react';
import { ArrecadacaoProvider } from './contexts/ArrecadacaoContext';
import { manutencaoArrecadacao } from './environments/environment';
import Routes from './routes/routes';

const queryClient = new QueryClient();

export const APP_SYSTEM_PATH = '/arrecadacao';

function App() {
  const auth = useAuth();
  useA11yTracking();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');

    if (token) {
      sessionStorage.clear();
      auth.setUrlToken(token);
    }
  }, []);

  return manutencaoArrecadacao.isAmbienteManutencao === 'true' ? (
    <ManutencaoArrecadacao />
  ) : (
    <QueryClientProvider client={queryClient}>
      <ArrecadacaoProvider>
        <Routes />
      </ArrecadacaoProvider>
    </QueryClientProvider>
  );
}

export default App;
